import FormDataSerializer from './form-data-serializer';
import JsonSerializer from './json-serializer';
import TextSerializer from './text-serializer';

export default {
  'Form': FormDataSerializer,
  'Json': JsonSerializer,
  'Text': TextSerializer
};



// WEBPACK FOOTER //
// ./src/serializers/index.js